/**
 * Theme entry — initializes all theme handlers on DOMContentLoaded.
 * Replaces dpss-theme.js + dpss-header-menu.js.
 */

import { injectAnimationStyles } from "./utils";
import { NavigationHandler } from "./navigation";
import { SitemapHandler } from "./sitemap";
import { AccessibilityHandler } from "./accessibility";
import { ScrollToTopHandler } from "./scroll-to-top";
import { PerformanceOptimizer } from "./performance";
import { initHeaderMenu } from "./header-menu";

// Inject CSS animation helpers immediately
injectAnimationStyles();

// Initialize all handlers when DOM is ready
// Note: search toggle is handled by initHeaderMenu() (KMU design: .js-search-toggle)
document.addEventListener("DOMContentLoaded", () => {
  new NavigationHandler();
  new SitemapHandler();
  new AccessibilityHandler();
  new ScrollToTopHandler();
  new PerformanceOptimizer();
  initHeaderMenu();
});
